import { getHeaders, handleResponse, SERVER_URL } from '../apiConfig';

const VIDEO_INDEX_BASE_URL = `${SERVER_URL}/api/video-index`;

export const fetchVideos = async (moduleId, search = '', sortOrder = 'DESC', page = 1, limit = 10, userRole = '') => {
  const query = `?search=${encodeURIComponent(search)}&sortOrder=${sortOrder}&page=${page}&limit=${limit}&userRole=${encodeURIComponent(userRole)}`;
  const response = await fetch(`${VIDEO_INDEX_BASE_URL}/${moduleId}${query}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const uploadVideoFile = async (formData, onProgress) => {
  const token = localStorage.getItem('token');
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${VIDEO_INDEX_BASE_URL}/upload`);
    xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    
    if (xhr.upload && onProgress) {
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          onProgress(event);
        }
      });
    }

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const res = JSON.parse(xhr.responseText);
          resolve(res);
        } catch (e) {
          resolve({ success: true, message: 'Success', raw: xhr.responseText });
        }
      } else {
        try {
          const res = JSON.parse(xhr.responseText);
          reject(new Error(res.message || `Request failed with status ${xhr.status}`));
        } catch (e) {
          reject(new Error(`Request failed with status ${xhr.status}`));
        }
      }
    };

    xhr.onerror = () => reject(new Error('Network error occurred.'));
    xhr.send(formData);
  });
};

export const trimVideoFile = async (trimData) => {
  const response = await fetch(`${VIDEO_INDEX_BASE_URL}/trim`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(trimData)
  });
  return handleResponse(response);
};

export const deleteVideoFile = async (videoId) => {
  const response = await fetch(`${VIDEO_INDEX_BASE_URL}/${videoId}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const copyVideoFile = async (copyFormData) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${VIDEO_INDEX_BASE_URL}/copy`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    },
    body: copyFormData
  });
  return handleResponse(response);
};

export const fetchVideoProgressApi = async (videoId) => {
  const response = await fetch(`${VIDEO_INDEX_BASE_URL}/progress/${videoId}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchVideoUploadInitApi = async (moduleId) => {
  const response = await fetch(`${VIDEO_INDEX_BASE_URL}/upload-init/${moduleId}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const getVideoDownloadUrl = (videoId) => {
  const token = localStorage.getItem('token') || '';
  return `${VIDEO_INDEX_BASE_URL}/download/${videoId}?token=${encodeURIComponent(token)}`;
};
